import React, { useState } from 'react';
import {
  Form,
  Select,
  Input,
  Button,
  Typography,
  Card,
  message,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { getDatabase, ref, get, update } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import Navbar1 from './Navbar';
import Footer1 from './Footer';

const { Option } = Select;
const { Title, Text } = Typography;

const HotelMarkup = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);






























// const handleSave = async () => {
//   try {
//     setLoading(true);
//     const values = await form.validateFields();
//     const { regionType, displayMarkup, value, status } = values;

//     // Check auth
//     const auth = getAuth();
//     if (!auth.currentUser) {
//       throw new Error('User not authenticated.');
//     }

//     const database = getDatabase();
//     const baseRef = ref(database, 'AgentPackages');
//     const snapshot = await get(baseRef);

//     if (!snapshot.exists()) {
//       throw new Error('No data found in AgentPackages.');
//     }

//     const allPackages = snapshot.val();
//     const region = regionType.toLowerCase();

//     if (!allPackages[region]) {
//       throw new Error(`No ${region} packages found.`);
//     }

//     const updates = {};
//     const timestamp = new Date().toISOString();
//     const markupValue = Number(value);

//     // Loop through all packages under region
//     for (const destination in allPackages[region]) {
//       const packagesByName = allPackages[region][destination];

//       for (const packageName in packagesByName) {
//         if (packageName === 'MarkupPrices') continue;

//         const pkg = packagesByName[packageName];

//         if (!pkg.price || isNaN(Number(pkg.price))) {
//           console.warn(`Skipping ${packageName}: Invalid price`);
//           continue;
//         }

//         const originalPrice = Number(pkg.price);
//         const finalPrice = originalPrice + markupValue;

//         const markupPath = `AgentPackages/${region}/${destination}/${packageName}/MarkupPrices`;
//         const packagePath = `AgentPackages/${region}/${destination}/${packageName}`;

//         // Set markup info
//         updates[markupPath] = {
//           originalPrice,
//           markupValue,
//           finalPrice,
//           markupType: displayMarkup,
//           status,
//           updatedAt: timestamp,
//         };

//         // Update base package metadata
//         updates[`${packagePath}/hasMarkup`] = true;
//         updates[`${packagePath}/lastUpdated`] = timestamp;
//       }
//     }

//     if (Object.keys(updates).length === 0) {
//       throw new Error('No valid packages to update.');
//     }

//     await update(ref(database), updates);
//     message.success(`Markup successfully applied to all ${region} packages!`);
//     form.resetFields();
//   } catch (error) {
//     console.error('Error saving markup:', error);
//     message.error(error.message || 'Failed to save markup.');
//   } finally {
//     setLoading(false);
//   }
// };






// const handleSave = async () => {
//   try {
//     setLoading(true);
//     const values = await form.validateFields();
//     const { regionType, displayMarkup, value, status } = values;

//     // ✅ Auth check
//     const auth = getAuth();
//     if (!auth.currentUser) {
//       throw new Error("User not authenticated.");
//     }

//     const database = getDatabase();
//     const baseRef = ref(database, "AgentPackages");
//     const snapshot = await get(baseRef);

//     if (!snapshot.exists()) {
//       throw new Error("No data found in AgentPackages.");
//     }

//     const allPackages = snapshot.val();
//     const region = regionType.toLowerCase();

//     if (!allPackages[region]) {
//       throw new Error(`No ${region} packages found.`);
//     }

//     const updates = {};
//     const timestamp = new Date().toISOString();
//     const markupValue = Number(value);

//     // ✅ Loop correctly: region → country → packageName
//     for (const country in allPackages[region]) {
//       const packagesByName = allPackages[region][country];

//       for (const packageName in packagesByName) {
//         if (packageName === "MarkupPrices") continue;

//         const pkg = packagesByName[packageName];

//         // ✅ Fix: support both "price" and "priceValues"
//         let originalPrice = 0;
//         if (pkg.price && !isNaN(Number(pkg.price))) {
//           originalPrice = Number(pkg.price);
//         } else if (pkg.priceValues) {
//           const firstValue = Array.isArray(pkg.priceValues)
//             ? pkg.priceValues[0]
//             : typeof pkg.priceValues === "object"
//             ? Object.values(pkg.priceValues)[0]
//             : pkg.priceValues;

//           if (firstValue) {
//             originalPrice = parseInt(String(firstValue).replace(/\D/g, "")) || 0;
//           }
//         }

//         if (!originalPrice) {
//           console.warn(`Skipping ${packageName}: Invalid price`);
//           continue;
//         }

//         const finalPrice = originalPrice + markupValue;

//         const markupPath = `AgentPackages/${region}/${country}/${packageName}/MarkupPrices`;
//         const packagePath = `AgentPackages/${region}/${country}/${packageName}`;

//         // ✅ Store markup info
//         updates[markupPath] = {
//           originalPrice,
//           markupValue,
//           finalPrice,
//           markupType: displayMarkup,
//           status,
//           updatedAt: timestamp,
//         };

//         // ✅ Update base package metadata
//         updates[`${packagePath}/hasMarkup`] = true;
//         updates[`${packagePath}/lastUpdated`] = timestamp;
//       }
//     }

//     if (Object.keys(updates).length === 0) {
//       throw new Error("No valid packages to update.");
//     }

//     // ✅ Push all updates in one go
//     await update(ref(database), updates);
//     message.success(`Markup successfully applied to all ${region} packages!`);
//     form.resetFields();
//   } catch (error) {
//     console.error("Error saving markup:", error);
//     message.error(error.message || "Failed to save markup.");
//   } finally {
//     setLoading(false);
//   }
// };










//   const handleSave = async () => {
//   try {
//     setLoading(true);
//     const values = await form.validateFields();
//     const { regionType, displayMarkup, value, status } = values;

//     // ✅ Auth check
//     const auth = getAuth();
//     if (!auth.currentUser) {
//       throw new Error("User not authenticated.");
//     }

//     const database = getDatabase();
//     const baseRef = ref(database, "AgentPackages");
//     const snapshot = await get(baseRef);

//     if (!snapshot.exists()) {
//       throw new Error("No data found in AgentPackages.");
//     }

//     const allPackages = snapshot.val();
//     const region = regionType.toLowerCase();

//     if (!allPackages[region]) {
//       throw new Error(`No ${region} packages found.`);
//     }

//     const updates = {};
//     const timestamp = new Date().toISOString();
//     const markupValue = Number(value);
//     const BASE_PRICE_ADJUSTMENT = 2000; // The amount to subtract before applying markup

//     // ✅ Loop correctly: region → country → packageName
//     for (const country in allPackages[region]) {
//       const packagesByName = allPackages[region][country];

//       for (const packageName in packagesByName) {
//         if (packageName === "MarkupPrices") continue;

//         const pkg = packagesByName[packageName];

//         // ✅ Fix: support both "price" and "priceValues"
//         let originalPrice = 0;
//         if (pkg.price && !isNaN(Number(pkg.price))) {
//           originalPrice = Number(pkg.price);
//         } else if (pkg.priceValues) {
//           const firstValue = Array.isArray(pkg.priceValues)
//             ? pkg.priceValues[0]
//             : typeof pkg.priceValues === "object"
//             ? Object.values(pkg.priceValues)[0]
//             : pkg.priceValues;

//           if (firstValue) {
//             originalPrice = parseInt(String(firstValue).replace(/\D/g, "")) || 0;
//           }
//         }

//         if (!originalPrice) {
//           console.warn(`Skipping ${packageName}: Invalid price`);
//           continue;
//         }

//         // First subtract 2000, then add the markup value
//         const adjustedPrice = originalPrice - BASE_PRICE_ADJUSTMENT;
//         const finalPrice = adjustedPrice + markupValue;

//         const markupPath = `AgentPackages/${region}/${country}/${packageName}/MarkupPrices`;
//         const packagePath = `AgentPackages/${region}/${country}/${packageName}`;

//         // ✅ Store markup info
//         updates[markupPath] = {
//           originalPrice,
//           baseAdjustment: -BASE_PRICE_ADJUSTMENT, // Store the adjustment for reference
//           adjustedPrice, // Store the price after base adjustment
//           markupValue,
//           finalPrice,
//           markupType: displayMarkup,
//           status,
//           updatedAt: timestamp,
//         };

//         // ✅ Update base package metadata
//         updates[`${packagePath}/hasMarkup`] = true;
//         updates[`${packagePath}/lastUpdated`] = timestamp;
//       }
//     }

//     if (Object.keys(updates).length === 0) {
//       throw new Error("No valid packages to update.");
//     }

//     // ✅ Push all updates in one go
//     await update(ref(database), updates);
//     message.success(`Markup successfully applied to all ${region} packages!`);
//     form.resetFields();
//   } catch (error) {
//     console.error("Error saving markup:", error);
//     message.error(error.message || "Failed to save markup.");
//   } finally {
//     setLoading(false);
//   }
// };




































const handleSave = async () => {
  try {
    setLoading(true);
    const values = await form.validateFields();
    const { regionType, displayMarkup, value, status } = values;

    // Auth check
    const auth = getAuth();
    if (!auth.currentUser) {
      throw new Error("User not authenticated.");
    }

    const database = getDatabase();
    const baseRef = ref(database, "AgentPackages");
    const snapshot = await get(baseRef);

    if (!snapshot.exists()) {
      throw new Error("No data found in AgentPackages.");
    }

    const allPackages = snapshot.val();
    const region = regionType.toLowerCase();

    if (!allPackages[region]) {
      throw new Error(`No ${region} packages found.`);
    }

    const updates = {};
    const timestamp = new Date().toISOString();
    const markupValue = Number(value);
    const BASE_PRICE_ADJUSTMENT = 2000;

    for (const country in allPackages[region]) {
      const packagesByName = allPackages[region][country];

      for (const packageName in packagesByName) {
        if (packageName === "MarkupPrices") continue;

        const pkg = packagesByName[packageName];
        const packagePath = `AgentPackages/${region}/${country}/${packageName}`;
        const markupPath = `${packagePath}/MarkupPrices`;

        // Handle packages with priceValues (array or object)
        if (pkg.priceValues) {
          let priceValues = pkg.priceValues;
          let updatedPriceValues = {};
          let originalPricesWithText = {}; // Store original prices with text
          let numericOriginalPrices = {}; // Store just numeric values for calculations

          // Convert array to object if needed
          if (Array.isArray(priceValues)) {
            priceValues = priceValues.reduce((acc, val, idx) => {
              acc[idx] = val;
              return acc;
            }, {});
          }

          // Process each price value
          for (const key in priceValues) {
            const priceStr = String(priceValues[key]);
            originalPricesWithText[key] = priceStr; // Store original with text
            
            // Extract numeric value for calculations
            const numericValue = parseInt(priceStr.replace(/\D/g, "")) || 0;
            numericOriginalPrices[key] = numericValue;
            
            // Apply adjustment and markup
            const adjustedPrice = numericValue - BASE_PRICE_ADJUSTMENT;
            const finalPrice = adjustedPrice + markupValue;
            
            // Format back to original format (preserve currency symbols etc.)
            updatedPriceValues[key] = priceStr.replace(/\d+/g, finalPrice.toString());
          }

          // Update priceValues with markup applied
          updates[`${packagePath}/priceValues`] = updatedPriceValues;

          // Store markup info with both formatted and numeric values
          updates[markupPath] = {
            originalPricesWithText, // Store original prices with all text formatting
            numericOriginalPrices, // Store just the numeric values
            baseAdjustment: -BASE_PRICE_ADJUSTMENT,
            markupValue,
            finalPrices: updatedPriceValues, // Store all final prices with formatting
            markupType: displayMarkup,
            status,
            updatedAt: timestamp,
          };
        } 
        // Handle simple price field
        else if (pkg.price && !isNaN(Number(pkg.price))) {
          const priceStr = String(pkg.price);
          const originalPrice = Number(pkg.price);
          const adjustedPrice = originalPrice - BASE_PRICE_ADJUSTMENT;
          const finalPrice = adjustedPrice + markupValue;
          const finalPriceWithText = priceStr.replace(/\d+/g, finalPrice.toString());

          updates[markupPath] = {
            originalPriceWithText: priceStr, // Store original with text
            numericOriginalPrice: originalPrice, // Store numeric value
            baseAdjustment: -BASE_PRICE_ADJUSTMENT,
            adjustedPrice,
            markupValue,
            finalPrice: finalPriceWithText, // Store final with same text format
            markupType: displayMarkup,
            status,
            updatedAt: timestamp,
          };

          // Update the main price with formatted value
          updates[`${packagePath}/price`] = finalPriceWithText;
        }

        // Update package metadata
        updates[`${packagePath}/hasMarkup`] = true;
        updates[`${packagePath}/lastUpdated`] = timestamp;
      }
    }

    if (Object.keys(updates).length === 0) {
      throw new Error("No valid packages to update.");
    }

    await update(ref(database), updates);
    message.success(`Markup successfully applied to all ${region} packages!`);
    form.resetFields();
  } catch (error) {
    console.error("Error saving markup:", error);
    message.error(error.message || "Failed to save markup.");
  } finally {
    setLoading(false);
  }
};










  return (
    <>
      <Navbar1 />
      <div
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          padding: '24px',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Card
          bordered={false}
          style={{
            marginBottom: '24px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
            background: 'linear-gradient(135deg, #f6f7f9 0%, #e9ebee 100%)',
          }}
          bodyStyle={{ padding: '16px 24px' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Title
              level={3}
              style={{
                margin: 0,
                color: '#2c3e50',
                fontWeight: 600,
              }}
            >
              ADMIN HOTEL MARKUP
            </Title>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => window.history.back()}
              style={{
                fontWeight: 500,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }}
            >
              Back
            </Button>
          </div>
        </Card>

        <Card
          bordered={false}
          style={{
            marginBottom: '24px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
          }}
          bodyStyle={{ padding: '24px' }}
        >
          <Title level={4} style={{ marginBottom: '20px', color: '#2c3e50' }}>
            APPLY MARKUP TO PACKAGES
          </Title>
          <Form layout="vertical" form={form}>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <div style={{ flex: 1, minWidth: '300px' }}>
                <Form.Item
                  label={<Text strong style={{ color: '#555' }}>Package Type *</Text>}
                  name="regionType"
                  rules={[{ required: true, message: 'Please select package type' }]}
                >
                  <Select placeholder="Select Package Type">
                    <Option value="domestic">domestic</Option>
                    <Option value="international">international</Option>
                  </Select>
                </Form.Item>
              </div>
              <div style={{ flex: 1, minWidth: '300px' }}>
                <Form.Item
                  label={<Text strong style={{ color: '#555' }}>Markup Type *</Text>}
                  name="displayMarkup"
                  rules={[{ required: true, message: 'Please select markup type' }]}
                >
                  <Select placeholder="Select Markup Type">
                    <Option value="In Tax">Included in Price</Option>
                    <Option value="Separate">Shown Separately</Option>
                  </Select>
                </Form.Item>
              </div>
              <div style={{ flex: 1, minWidth: '300px' }}>
                <Form.Item
                  label={<Text strong style={{ color: '#555' }}>Markup Value (₹) *</Text>}
                  name="value"
                  rules={[
                    { required: true, message: 'Please enter markup value' },
                    {
                      pattern: /^[0-9]+$/,
                      message: 'Please enter a valid number',
                    },
                    {
                      validator: (_, val) =>
                        Number(val) > 0
                          ? Promise.resolve()
                          : Promise.reject('Markup value must be positive'),
                    },
                  ]}
                >
                  <Input placeholder="Enter markup amount" type="number" min="1" />
                </Form.Item>
              </div>
              <div style={{ flex: 1, minWidth: '300px' }}>
                <Form.Item
                  label={<Text strong style={{ color: '#555' }}>Status *</Text>}
                  name="status"
                  rules={[{ required: true, message: 'Please select status' }]}
                >
                  <Select placeholder="Select Status">
                    <Option value="Active">Active</Option>
                    <Option value="Inactive">Inactive</Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '8px',
                marginTop: '24px',
              }}
            >
              <Button onClick={() => form.resetFields()} disabled={loading}>
                Reset
              </Button>
              <Button
                type="primary"
                onClick={handleSave}
                loading={loading}
                style={{
                  fontWeight: 500,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                }}
              >
                APPLY MARKUP
              </Button>
            </div>
          </Form>
        </Card>
      </div>
      <Footer1 />
    </>
  );
};

export default HotelMarkup;













